var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "activate",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1799 10.2399L11.4299 14.9899C11.2599 15.1599 11.0399 15.2399 10.8099 15.2399C10.5899 15.2399 10.3699 15.1599 10.1999 14.9899L7.81994 12.6199C7.47994 12.2699 7.47994 11.7199 7.81994 11.3799C8.15994 11.0399 8.71994 11.0399 9.05994 11.3799L10.8099 13.1299L14.9399 8.99987C15.2799 8.65987 15.8399 8.65987 16.1799 8.99987C16.5199 9.34987 16.5199 9.89987 16.1799 10.2399Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/Activate.761636bf.svg";
export { ForwardRef as ReactComponent };